import React from "react";

function AboutMe() {
  return (
    <div
      className="container"
      style={{
        margin: "100px 0px",
      }}
    >
      <div className="row g-5 justify-content-center">
        <div className="text-center">
          <h2>
            <span className="border-reddish pb-1">Abo</span>ut Me
          </h2>
        </div>
        <div className="col-md-4 d-flex flex-column gap-3">
          <div>
            <img
              src="/image/about1.png"
              alt="About 1"
              className="img-fluid rounded about-img"
            />
          </div>
          <div>
            <img
              src="/image/about2.png"
              alt="About 2"
              className="img-fluid rounded about-img"
            />
          </div>
        </div>

        {/* Text Content */}
        <div className="col-md-7">
          {/* <div className="text-center d-md-block d-none">
            <h2>
              <span className="border-reddish pb-1">Abo</span>ut Me
            </h2>
          </div> */}
          <div>
            <p className="text-justify" style={{ fontSize: "15px" }}>
              I am a UX designer who’s all about crafting meaningful,
              people-first experiences. My background in behavioral psychology
              gives me a unique edge in understanding how users think, feel, and
              interact with designs—and that insight drives everything I create.
              To me, UX isn’t just about solving problems (though that’s a big
              part of it); it’s about making technology feel human and intuitive
              while leaving users with a sense of “wow, that just works!”
            </p>
            <p className="text-justify" style={{ fontSize: "15px" }}>
              The journey to where I am now hasn’t been a straight line—it’s
              been filled with learning, freelancing, experimenting, and
              figuring out how to balance life with my passion for design. Along
              the way, I’ve built a solid foundation in user research,
              wireframing, prototyping, and designing interfaces that don’t just
              work but feel good to use. I love the process of collaborating,
              digging into challenges, and delivering thoughtful, creative
              solutions.
            </p>
            <p className="text-justify" style={{ fontSize: "15px" }}>
              But here’s the thing: I’m not just a designer—I’m a people person.
              I feel things deeply, and I pour that same energy into my work.
              Whether I’m working on a design sprint, tackling user pain points,
              or brainstorming bold ideas, I’m driven by empathy and curiosity.
              I believe that great design isn’t just functional; it connects
              with people on a personal level.
            </p>
            <p className="text-justify" style={{ fontSize: "15px" }}>
              Outside of work, I’m always finding new ways to stay
              inspired—whether that’s through dance, reflecting on my faith, or
              just enjoying little moments of creativity in the everyday. I’m
              always up for a challenge, and I genuinely believe in growing
              through everything life throws my way.
            </p>
            <p className="text-justify" style={{ fontSize: "15px" }}>
              I’m excited to bring my passion and perspective to projects that
              matter, collaborate with awesome teams, and create designs that
              make life just a little easier—and a lot more fun.
            </p>
          </div>
          <div className="d-flex justify-content-center m-auto">
            <a
              href="https://storage.googleapis.com/uxfolio/64793b4efb157900025506db/Chinaza_Eskay__2__9Vb.pdf"
              target="_blank"
              rel="noreferrer"
              style={{
                width: "50%",
              }}
            >
              <button type="button" className="bg-white button-outline mt-3">
                Download CV
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutMe;
